export const EVENT_ACTION_SCHEDULING_MODAL_LAUNCH_CLICK =
  'SCHEDULING_MODAL_LAUNCH_CLICK';
